import {Heading} from "../../../components";
import Activation from "../../../components/Activation";
import React, {Suspense} from "react";
import { useTranslation } from "react-i18next"

export default function ActivationSection() {

    const {t} = useTranslation();

    const ActivationStepGrip = [
        {
            stepNumber: "01",
            stepDescription: t("activation.description.1"),
            stepDescriptionSM: t("activation.description.1sm")
        },
        {
            stepNumber: "02",
            stepDescription: t("activation.description.2"),
            stepDescriptionSM: t("activation.description.2sm")
        },
        {
            stepNumber: "03",
            stepDescription: t("activation.description.3"),
            stepDescriptionSM: t("activation.description.3sm")
        },

        {stepNumber: "04",
            stepDescription: t("activation.description.4"),
            stepDescriptionSM: t("activation.description.4sm")
        },
    ];

    return (
        <>
            <section id="activation">
                <div className="flex justify-center px-6 md:px-5 sm:px-[16px]">
                    <div className="container-xs flex justify-center">
                        <div className="w-full rounded-[99999px] md:rounded-[64px] sm:rounded-[32px] bg-[#333333] px-20 md:px-6 py-[145.5px] md:py-6 sm:px-6 sm:py-6">
                            <div className="mb-[22px] flex items-center lg:justify-between md:grid sm:grid gap-5 md:gap-12">
                                <Heading
                                    size="desktop_heading_2"
                                    className='sm:hidden font-medium text-[#FFFFFF] lg:w-[515px]'>
                                    {t("activation.title")}
                                </Heading>
                                <Heading
                                    size="desktop_heading_5"
                                    className='lg:hidden md:hidden font-medium text-[#FFFFFF]'>
                                    {t("activation.title")}
                                </Heading>
                                <div className="lg:ml-[111px] grid lg:w-[54%] grid-cols-2 gap-5 gap-y-10 sm:gap-x-2 sm:gap-y-2">
                                    <Suspense fallback={null}>
                                        {ActivationStepGrip.map((d, index)=>(
                                            <Activation {...d} key={"grid" + index}/>
                                        ))}
                                    </Suspense>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}